module.exports = __webpack_public_path__ + "static/media/proj9_img1.c230d712.jpg";